<div class="message-bar-shell">
	@if (promptSuggestionsEnabled()) {
	<div class="message-bar__suggestion-slot">
		@if (showPromptSuggestionsButton()) {
		<button type="button" class="message-bar__suggestion-button"
			[class.message-bar__suggestion-button--active]="promptSuggestionsOpen()"
			[class.message-bar__suggestion-button--highlight]="promptSuggestionsLoading()"
			(click)="togglePromptSuggestions()" [attr.aria-label]="'chat.promptSuggestions.open' | translate">
			<app-icon icon="fa-regular fa-lightbulb" [width]="22" [height]="22" />
		</button>
		}
	</div>
	}

	<div class="message-bar__composer-wrap">
		@if (promptSuggestionsOpen()) {
		<app-prompt-suggestion class="message-bar__prompt-suggestion" [suggestions]="promptSuggestions()"
			[loading]="promptSuggestionsLoading()" (closed)="closePromptSuggestions()"
			(refreshed)="refreshPromptSuggestions()"
			(exampleSelected)="insertPromptSuggestionExample($event)"></app-prompt-suggestion>
		}

		<div class="message-bar">
			@if (hasAttachments()) {
			<div class="message-bar__attachments" [attr.aria-label]="'chat.messageBar.selectedFiles' | translate">
				@for (attachment of uploadingMediaAttachments(); track attachment.uploadId) {
				<div class="message-bar__attachment message-bar__attachment--uploading">
					<span class="message-bar__attachment-spinner" aria-hidden="true"></span>
					<div class="message-bar__attachment-text">
						<strong>{{ attachment.fileName }}</strong>
						<span>{{ getUploadingMediaKind(attachment) }}</span>
						<span class="message-bar__attachment-progress" aria-hidden="true">
							<span [style.width.%]="attachment.progress"></span>
						</span>
					</div>
				</div>
				}
				@for (attachment of mediaAttachments(); track attachment.mediaId) {
				<div class="message-bar__attachment" [class.message-bar__attachment--image]="isImageMedia(attachment)">
					@if (isImageMedia(attachment)) {
					<img class="message-bar__attachment-preview" [src]="attachment.mediaUrl"
						[alt]="attachment.fileName" />
					} @else {
					<app-icon class="message-bar__attachment-icon" icon="icon-file-pdf-solid.svg" [width]="30"
						[height]="30" />
					<div class="message-bar__attachment-text">
						<strong>{{ attachment.fileName }}</strong>
						<span>{{ getMediaKind(attachment) }}</span>
					</div>
					}

					<button type="button" class="message-bar__attachment-remove"
						(click)="removeMediaAttachment(attachment.mediaId)"
						[attr.aria-label]="'chat.messageBar.removeFile' | translate">
						<app-icon icon="icon-close-solid.svg" color="var(--white)" [width]="8" [height]="8" />
					</button>
				</div>
				}
			</div>
			}

			<div class="message-bar__row">
				<div class="message-bar__menu-host">
					<button class="message-bar__icon-button" type="button"
						(click)="uploadFile(); $event.stopPropagation()"
						[attr.aria-label]="'chat.messageBar.openAttachments' | translate">
						<app-icon icon="icon-add-regular.svg" color="currentColor" [width]="18" [height]="18" />
					</button>
				</div>

				@if (isRecording()) {
				<div class="message-bar__recorder" aria-live="polite">
					<span class="message-bar__rec-dot" aria-hidden="true"></span>
					<span class="message-bar__rec-label">{{ 'chat.messageBar.recordingLabel' | translate }}</span>
					<div #visualizerHost class="message-bar__visualizer" aria-hidden="true"></div>
				</div>
				} @else if (isTranscribing()) {
				<div class="message-bar__transcribing" aria-live="polite">{{ 'chat.messageBar.transcribing' | translate
					}}</div>
				} @else {
				<textarea #messagebar #autosize="cdkTextareaAutosize" cdkTextareaAutosize [cdkAutosizeMinRows]="1"
					[cdkAutosizeMaxRows]="7" rows="1" [ngModel]="prompt()" (ngModelChange)="onPromptChange($event)"
					(keydown.enter)="onEnter($event)" [placeholder]="'chat.messageBar.placeholder' | translate"
					(focus)="onTextareaFocus()"
					(paste)="onTextareaPaste($event)"
					[attr.aria-label]="'chat.messageBar.placeholder' | translate"></textarea>
				}

				<button class="message-bar__send-button" type="button" (click)="toggleRecording()"
					(mousedown)="preserveTextareaFocus($event)"
					[disabled]="showSpinner"
					[attr.aria-label]="isStreaming() ? ('chat.messageBar.stopStreaming' | translate) : (canSend ? ('chat.messageBar.sendMessage' | translate) : (isRecording() ? ('chat.messageBar.stopRecording' | translate) : ('chat.messageBar.startRecording' | translate)))">
					@if (showSpinner) {
					<span class="message-bar__spinner" aria-hidden="true"></span>
					} @else if (isStreaming()) {
					<span class="message-bar__stop" aria-hidden="true"></span>
					} @else if (canSend) {
					<app-icon icon="icon-arrow-right-solid.svg" color="var(--white)" [width]="18" [height]="18" />
					} @else if (isRecording()) {
					<span class="message-bar__stop" aria-hidden="true"></span>
					} @else {
					<app-icon icon="icon-microphone-regular.svg" color="var(--white)" [width]="18" [height]="18" />
					}
				</button>
			</div>

			<input #fileInput type="file" multiple hidden (change)="onFilesSelected($event)" [attr.aria-label]="'chat.messageBar.openAttachments' | translate" />
		</div>
	</div>
</div>
